ScoreTrekBattle.Settings = ScoreTrekBattle.Settings || {};
ScoreTrekBattle.Settings.League = ScoreTrekBattle.Settings.League || {};

ScoreTrekBattle.Settings.League.Preset = (function() {
    var _this, STATUS, CONFIG;

    CONFIG = {
        GAMES: [
            'game08',
            'game09',
            'game10',
            'gameMulti',
            'game14',
            'gameOnePocket',
            'gameBankPool',
            'gameHeyball',
            'gameCarom',
            'gameSnooker'
        ],
        DEFAULT_TARGETS: {
            'game08': 5,
            'game09': 5,
            'game10': 5,
            'gameMulti': 5,
            'game14': 75,
            'gameOnePocket': 8,
            'gameBankPool': 5,
            'gameHeyball': 5,
            'gameCarom': 100,
            'gameSnooker': 3
        },
        ALTERNATING_BREAK_GAMES: [
            'game08',
            'game09',
            'game10',
            'gameMulti',
            'gameOnePocket',
            'gameBankPool',
            'gameHeyball'
        ],
        TAKE_LIMIT_GAMES: [
            'game14',
            'gameCarom'
        ]
    };

    function resetStatus() {
        STATUS = {
            active: false,
            view: null,
            $view: null,
            $rounds: null,
            seasonId: '',
            leagueId: '',
            leagueName: '',
            isFallback: false,
            exists: false,
            rounds: []
        };
    }
    resetStatus();

    function open($container, seasonId, leagueId, leagueName, isFallback) {
        resetStatus();

        STATUS.seasonId = seasonId;
        STATUS.leagueId = leagueId;
        STATUS.leagueName = leagueName || leagueId;
        STATUS.isFallback = !!isFallback;

        $container.empty();

        ScoreTrekBattle.View.loading('Settings.League.Preset.load', true);

        return Api.request('/battle/league/editor/preset/load', {
            seasonId: seasonId,
            leagueId: leagueId
        }).then(result => {
            return render($container, result.preset || null);
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.League.Preset.load', false);
        });
    }

    function render($container, preset) {
        return ScoreTrekBattle.Template.render('settings/league/preset').then(view => {
            STATUS.active = true;
            STATUS.view = view;
            STATUS.$view = view.$view;
            STATUS.$rounds = view.$view.find('[data-id="rounds"]');
            STATUS.exists = (preset !== null);
            STATUS.rounds = buildRounds(preset);

            applyHeader(preset);
            applyConfig(preset ? (preset.config || {}) : {});

            view.$view.find('[data-id="fallbackHint"]').toggle(STATUS.isFallback);

            view.$view.find('[data-id="delete"]').toggle(STATUS.exists);

            $container.append(view.$view);

            renderRounds();
        });
    }

    function buildRounds(preset) {
        var forfeitMatches, isDoublePreset, rounds;

        if (!preset || !Array.isArray(preset.rounds) || (preset.rounds.length === 0)) {
            return [
                {name: __i18n('league/editor/preset/roundNumber', {number: 1}), matches: [buildMatch(false)]},
                {name: __i18n('league/editor/preset/roundNumber', {number: 2}), matches: [buildMatch(false)]}
            ];
        }

        forfeitMatches = (preset.config && Array.isArray(preset.config.forfeitMatchesBelowFull))
            ? preset.config.forfeitMatchesBelowFull
            : [];

        isDoublePreset = (preset.playerType === 'double');

        rounds = [];

        preset.rounds.forEach(round => {
            var matches;

            matches = [];

            (round.matches || []).forEach(match => {
                matches.push({
                    gameType: match.gameType || '',
                    gameTarget: parseInt(match.gameTarget, 10) || 0,
                    takeLimit: parseInt(match.takeLimit, 10) || 0,
                    timeLimit: parseInt(match.timeLimit, 10) || 0,
                    alternatingBreak: !!match.alternatingBreak,
                    isDouble: match.hasOwnProperty('teamSize') ? (parseInt(match.teamSize, 10) === 2) : isDoublePreset,
                    isForfeit: (forfeitMatches.indexOf(parseInt(match.index, 10)) >= 0)
                });
            });

            rounds.push({
                name: round.name || '',
                matches: matches
            });
        });

        return rounds;
    }

    function buildMatch(isDouble) {
        return {
            gameType: '',
            gameTarget: 0,
            takeLimit: 0,
            timeLimit: 0,
            alternatingBreak: false,
            isDouble: !!isDouble,
            isForfeit: false
        };
    }

    function isDoublePreset() {
        return (STATUS.view && (STATUS.view.controls.playerType.get() === 'double'));
    }

    function applyHeader(preset) {
        var controls;

        controls = STATUS.view.controls;

        controls.name.set(preset ? preset.name : buildDefaultName());
        controls.version.set(preset ? preset.version : '');

        controls.playerType.set((preset && (preset.playerType === 'double')) ? 'double' : 'single');
    }

    function buildDefaultName() {
        return `${STATUS.leagueName} ${seasonLabel()}`.trim();
    }

    function seasonLabel() {
        return ScoreTrekBattle.Settings.League.Editor.getSeasonName(STATUS.seasonId) || STATUS.seasonId;
    }

    function applyConfig(config) {
        var controls, points;

        controls = STATUS.view.controls;
        points = config.points || {};

        controls.matchesPerPlayer.set(numberOrDefault(config.matchesPerPlayer, 2));
        controls.minPlayers.set(numberOrDefault(config.minPlayers, 0));

        controls.onePerRound.set(!config.hasOwnProperty('onePerRound') || !!config.onePerRound);
        controls.disciplineRule.set(getDisciplineRule(config));

        controls.pointsWin.set(numberOrDefault(points.win, 2));
        controls.pointsDraw.set(numberOrDefault(points.draw, 1));
        controls.pointsLoss.set(numberOrDefault(points.loss, 0));

        controls.breakFormat.set(config.breakFormat || '');
        controls.source.set(config.source || '');
    }

    function getDisciplineRule(config) {
        if (['none', 'all', 'singles'].indexOf(config.disciplineRule) >= 0) {
            return config.disciplineRule;
        }

        return config.onePerDisciplineAndRound ? 'all' : 'none';
    }

    function numberOrDefault(value, fallback) {
        var number;

        number = parseInt(value, 10);

        return isNaN(number) ? fallback : number;
    }

    function renderRounds() {
        var promises;

        if (!STATUS.$rounds) {
            return;
        }

        promises = [];

        STATUS.rounds.forEach((round, roundIndex) => {
            promises.push(renderRound(round, roundIndex));
        });

        Promise.all(promises).then($rounds => {
            STATUS.$rounds.empty();
            STATUS.$rounds.append($rounds);
        });
    }

    function renderRound(round, roundIndex) {
        return ScoreTrekBattle.Template.render('settings/league/presetRound').then(view => {
            var $matches, promises;

            view.$view.find('[data-id="roundTitle"]').text(
                __i18n('league/editor/preset/roundNumber', {number: (roundIndex + 1)})
            );

            view.controls.roundName.set(round.name);
            view.controls.roundName.on('change', function() {
                round.name = this.get();
            });

            view.$view.find('[data-id="removeRound"]').toggle(STATUS.rounds.length > 1).on('click', function() {
                STATUS.rounds.splice(roundIndex, 1);
                renderRounds();
            });

            view.$view.find('[data-id="addMatch"]').on('click', function() {
                round.matches.push(buildMatch(isDoublePreset()));
                renderRounds();
            });

            $matches = view.$view.find('[data-id="matches"]');
            promises = [];

            round.matches.forEach((match, matchIndex) => {
                promises.push(renderMatch(round, match, matchIndex, matchNumber(roundIndex, matchIndex)));
            });

            return Promise.all(promises).then($rows => {
                $matches.append($rows);
                return view.$view;
            });
        });
    }

    function matchNumber(roundIndex, matchIndex) {
        var number;

        number = matchIndex + 1;

        STATUS.rounds.slice(0, roundIndex).forEach(round => {
            number += round.matches.length;
        });

        return number;
    }

    function renderMatch(round, match, matchIndex, number) {
        return ScoreTrekBattle.Template.render('settings/league/presetMatch').then(view => {
            var controls;

            controls = view.controls;

            view.$view.find('[data-id="matchIndex"]').text(`#${number}`);

            controls.gameType.setOptions(buildGameOptions(), {'': `- ${__i18n('filter/pleaseSelect')} -`});
            controls.gameType.set(match.gameType);
            controls.gameType.on('change', function() {
                var gameType;

                gameType = this.get();

                if (gameType !== match.gameType) {
                    match.gameType = gameType;
                    match.gameTarget = CONFIG.DEFAULT_TARGETS[gameType] || 0;
                    controls.gameTarget.set(match.gameTarget);
                }

                applyGameTypeLimits(controls, match);
            });

            controls.gameTarget.set(match.gameTarget);
            controls.gameTarget.on('change', function() {
                match.gameTarget = parseInt(this.get(), 10) || 0;
            });

            controls.takeLimit.set(match.takeLimit);
            controls.takeLimit.on('change', function() {
                match.takeLimit = parseInt(this.get(), 10) || 0;
            });

            controls.timeLimit.set(match.timeLimit);
            controls.timeLimit.on('change', function() {
                match.timeLimit = parseInt(this.get(), 10) || 0;
            });

            controls.alternatingBreak.set(match.alternatingBreak);
            controls.alternatingBreak.on('change', function() {
                match.alternatingBreak = this.get();
            });

            controls.isDouble.set(match.isDouble);
            controls.isDouble.on('change', function() {
                match.isDouble = this.get();
            });

            controls.isForfeit.set(match.isForfeit);
            controls.isForfeit.on('change', function() {
                match.isForfeit = this.get();
            });

            view.$view.find('[data-id="removeMatch"]').toggle(round.matches.length > 1).on('click', function() {
                round.matches.splice(matchIndex, 1);
                renderRounds();
            });

            applyGameTypeLimits(controls, match);

            return view.$view;
        });
    }

    function applyGameTypeLimits(controls, match) {
        var allowTakeLimit, allowAlternatingBreak;

        allowTakeLimit = (CONFIG.TAKE_LIMIT_GAMES.indexOf(match.gameType) >= 0);
        allowAlternatingBreak = (CONFIG.ALTERNATING_BREAK_GAMES.indexOf(match.gameType) >= 0);

        controls.takeLimit.disable(!allowTakeLimit);
        controls.alternatingBreak.disable(!allowAlternatingBreak);

        if (!allowTakeLimit && (match.takeLimit !== 0)) {
            match.takeLimit = 0;
            controls.takeLimit.set(0);
        }

        if (!allowAlternatingBreak && match.alternatingBreak) {
            match.alternatingBreak = false;
            controls.alternatingBreak.set(false);
        }
    }

    function buildGameOptions() {
        var options;

        options = {};

        CONFIG.GAMES.forEach(gameType => {
            options[gameType] = __i18n(`gameType/${gameType}`);
        });

        return options;
    }

    function addRound() {
        STATUS.rounds.push({
            name: __i18n('league/editor/preset/roundNumber', {number: (STATUS.rounds.length + 1)}),
            matches: [buildMatch(isDoublePreset())]
        });

        renderRounds();
    }

    function collect() {
        var controls, rounds, forfeitMatches, number;

        controls = STATUS.view.controls;

        rounds = [];
        forfeitMatches = [];
        number = 0;

        STATUS.rounds.forEach(round => {
            var matches;

            matches = [];

            round.matches.forEach(match => {
                number++;

                if (match.isForfeit) {
                    forfeitMatches.push(number);
                }

                matches.push({
                    gameType: match.gameType,
                    gameTarget: match.gameTarget,
                    takeLimit: match.takeLimit,
                    timeLimit: match.timeLimit,
                    alternatingBreak: match.alternatingBreak,
                    teamSize: match.isDouble ? 2 : 1
                });
            });

            rounds.push({
                name: round.name,
                matches: matches
            });
        });

        return {
            seasonId: STATUS.seasonId,
            leagueId: STATUS.leagueId,
            name: controls.name.get(),
            version: controls.version.get(),
            preset: {
                playerType: controls.playerType.get(),
                rounds: rounds
            },
            config: {
                matchesPerPlayer: parseInt(controls.matchesPerPlayer.get(), 10) || 0,
                onePerRound: controls.onePerRound.get(),
                disciplineRule: controls.disciplineRule.get(),
                minPlayers: parseInt(controls.minPlayers.get(), 10) || 0,
                forfeitMatchesBelowFull: forfeitMatches,
                points: {
                    win: parseInt(controls.pointsWin.get(), 10) || 0,
                    draw: parseInt(controls.pointsDraw.get(), 10) || 0,
                    loss: parseInt(controls.pointsLoss.get(), 10) || 0
                },
                breakFormat: controls.breakFormat.get(),
                source: controls.source.get()
            }
        };
    }

    function collectErrors(data) {
        var errors;

        errors = [];

        if (String(data.name).trim() === '') {
            errors.push({field: 'name', message: __i18n('league/editor/error/missingName')});
        }

        return errors;
    }

    function save() {
        var data, errors;

        data = collect();
        errors = collectErrors(data);

        if (errors.length > 0) {
            STATUS.view.forms.preset.errors(errors);
            return;
        }

        ScoreTrekBattle.View.loading('Settings.League.Preset.save', true);

        Api.request('/battle/league/editor/preset/save', data).then(result => {
            STATUS.exists = true;
            STATUS.$view.find('[data-id="delete"]').show();
            STATUS.rounds = buildRounds(result.preset);
            renderRounds();
            chmDialog.success(__i18n('league/editor/preset/saved'));
        }).catch(error => {
            ScoreTrekBattle.Settings.League.Editor.showError(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Settings.League.Preset.save', false);
        });
    }

    function confirmDelete() {
        chmDialog.confirm(__i18n('dialog/confirm/delete/text', {colorClass: 'color-blue', reference: STATUS.leagueName}, true), {
            title: __i18n('dialog/confirm/delete/title'),
            buttonYes: __i18n('button/delete'),
            buttonNo: __i18n('button/cancel')
        }).then(() => {
            ScoreTrekBattle.View.loading('Settings.League.Preset.delete', true);

            Api.request('/battle/league/editor/preset/delete', {
                seasonId: STATUS.seasonId,
                leagueId: STATUS.leagueId
            }).then(() => {
                ScoreTrekBattle.Settings.League.Editor.refresh();
            }).catch(error => {
                ScoreTrekBattle.Settings.League.Editor.showError(error);
            }).finally(() => {
                ScoreTrekBattle.View.loading('Settings.League.Preset.delete', false);
            });
        }).catch(ignore => {});
    }

    ScoreTrekBattle.Event.on('action.leagueEditor.preset.roundAdd', function() {
        if (!STATUS.active) {
            return;
        }

        addRound();
    });

    ScoreTrekBattle.Event.on('action.leagueEditor.preset.save', function() {
        if (!STATUS.active) {
            return;
        }

        save();
    });

    ScoreTrekBattle.Event.on('action.leagueEditor.preset.delete', function() {
        if (!STATUS.active) {
            return;
        }

        confirmDelete();
    });

    _this = {
        open: function($container, seasonId, leagueId, leagueName, isFallback) {
            return open($container, seasonId, leagueId, leagueName, isFallback);
        },
        close: function() {
            resetStatus();
        }
    };

    return _this;
})();
